import { render } from "./CourseCardsComponent.vue?vue&type=template&id=f9e53482&scoped=true"
import script from "./CourseCardsComponent.vue?vue&type=script&lang=js"
export * from "./CourseCardsComponent.vue?vue&type=script&lang=js"

import "./CourseCardsComponent.vue?vue&type=style&index=0&id=f9e53482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9e53482"]])

export default __exports__